app.controller("SubjectDetailsController", ["$scope", "Subject", "StaticData", "ProgramService", "$uibModal", "ConfirmModal", "$stateParams", "$state", "usSpinnerService",
    function ($scope, Subject, StaticData, ProgramService, $uibModal, ConfirmModal, $stateParams, $state, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.subject = null;
        $scope.query = $stateParams.query;
        $scope.semester = $stateParams.semester || 'სემესტრი';
        $scope.subjectState = $stateParams.subjectState;
        $scope.state = $stateParams.state;
        $scope.faculty = $stateParams.faculty;
        $scope.level = $stateParams.level;
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));

        if ($stateParams.program) {
            ProgramService.fetchOne($stateParams.program).then(function (program) {
                $scope.program = program;
            });
        }

        Subject.fetchOne($stateParams.subjectId).then(function (data) {
            $scope.subject = data.subject;
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        StaticData.getItemsByKey("subject_states").then(function (states) {
            $scope.subjectStates = [{name: "საგნის სტატუსი"}].concat(states);
            $scope.subjectStatesMap = _.keyBy($scope.states, '_id');
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = [{name: "სტუდენტის სტატუსი"}].concat(states);
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            Subject.details($stateParams.subjectId, {
                page: page,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                faculty: $scope.faculty,
                level: $scope.level,
                state: $scope.state,
                subjectState: $scope.subjectState,
                program: $stateParams.program,
                semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined
            }).then(function (data) {
                $scope.selections = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            })
        }

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };


        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.faculty,
                level: $scope.level,
                state: $scope.state,
                subjectState: $scope.subjectState,
                program: $scope.program ? $scope.program._id : undefined,
                semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined
            });
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.details = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "DetailsController",
                templateUrl: _pb + 'student/card/details.html',
                size: "md",
                resolve: {
                    subject: function () {
                        return subject
                    }
                }
            }).result
                .then(function (result) {

                });
        };

        $scope.card = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go('admin.studentCard', {studentId: subject.profile._id, student: subject.profile})
        };
    }
]);